export var FontFamily;
(function (FontFamily) {
    FontFamily["DEFAULT"] = "default";
    FontFamily["ARIAL"] = "Arial";
    FontFamily["TAHOMA"] = "Tahoma";
    FontFamily["TIMES"] = "Times New Roman";
    FontFamily["VERDANA"] = "Verdana";
})(FontFamily || (FontFamily = {}));
export var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["DEFAULT"] = 1] = "DEFAULT";
    FontWeight[FontWeight["BOLD"] = 2] = "BOLD";
})(FontWeight || (FontWeight = {}));
export var FontSize;
(function (FontSize) {
    FontSize[FontSize["DEFAULT"] = 0] = "DEFAULT";
    FontSize[FontSize["EIGHT"] = 8] = "EIGHT";
    FontSize[FontSize["NINE"] = 9] = "NINE";
    FontSize[FontSize["TEN"] = 10] = "TEN";
    FontSize[FontSize["TWELVE"] = 12] = "TWELVE";
    FontSize[FontSize["FOURTEEN"] = 14] = "FOURTEEN";
    FontSize[FontSize["SIXTEEN"] = 16] = "SIXTEEN";
    FontSize[FontSize["EIGHTEEN"] = 18] = "EIGHTEEN";
    FontSize[FontSize["TWENTY"] = 20] = "TWENTY";
    FontSize[FontSize["TWENTY_FOUR"] = 24] = "TWENTY_FOUR";
    FontSize[FontSize["TWENTY_EIGHT"] = 28] = "TWENTY_EIGHT";
    FontSize[FontSize["THIRTY_TWO"] = 32] = "THIRTY_TWO";
    FontSize[FontSize["THIRTY_SIX"] = 36] = "THIRTY_SIX";
})(FontSize || (FontSize = {}));
export var DecimalCount;
(function (DecimalCount) {
    DecimalCount[DecimalCount["DEFAULT"] = 1] = "DEFAULT";
    DecimalCount[DecimalCount["ZERO"] = 2] = "ZERO";
    DecimalCount[DecimalCount["ONE"] = 3] = "ONE";
    DecimalCount[DecimalCount["TWO"] = 4] = "TWO";
    DecimalCount[DecimalCount["THREE"] = 5] = "THREE";
    DecimalCount[DecimalCount["FOUR"] = 6] = "FOUR";
    DecimalCount[DecimalCount["FIVE"] = 7] = "FIVE";
})(DecimalCount || (DecimalCount = {}));
export var ThousandsSeparator;
(function (ThousandsSeparator) {
    ThousandsSeparator[ThousandsSeparator["NONE"] = 1] = "NONE";
    ThousandsSeparator[ThousandsSeparator["COMMA"] = 2] = "COMMA";
})(ThousandsSeparator || (ThousandsSeparator = {}));
export var NumberFormat;
(function (NumberFormat) {
    NumberFormat[NumberFormat["NONE"] = 1] = "NONE";
    NumberFormat[NumberFormat["NUMBER"] = 2] = "NUMBER";
    NumberFormat[NumberFormat["CURRENCY"] = 3] = "CURRENCY";
    NumberFormat[NumberFormat["PERCENT"] = 4] = "PERCENT";
})(NumberFormat || (NumberFormat = {}));
export var NegativeStyle;
(function (NegativeStyle) {
    NegativeStyle[NegativeStyle["NONE"] = 0] = "NONE";
    NegativeStyle[NegativeStyle["SIGN_BLACK"] = 1] = "SIGN_BLACK";
    NegativeStyle[NegativeStyle["PAREN_BLACK"] = 2] = "PAREN_BLACK";
    NegativeStyle[NegativeStyle["SIGN_RED"] = 3] = "SIGN_RED";
    NegativeStyle[NegativeStyle["PAREN_RED"] = 4] = "PAREN_RED";
})(NegativeStyle || (NegativeStyle = {}));
export var TextWrap;
(function (TextWrap) {
    TextWrap[TextWrap["NONE"] = 0] = "NONE";
    TextWrap[TextWrap["ON"] = 1] = "ON";
})(TextWrap || (TextWrap = {}));
export var HorizontalAlignment;
(function (HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["DEFAULT"] = 1] = "DEFAULT";
    HorizontalAlignment[HorizontalAlignment["RIGHT"] = 2] = "RIGHT";
    HorizontalAlignment[HorizontalAlignment["LEFT"] = 3] = "LEFT";
    HorizontalAlignment[HorizontalAlignment["CENTER"] = 4] = "CENTER";
})(HorizontalAlignment || (HorizontalAlignment = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["DEFAULT"] = 1] = "DEFAULT";
    VerticalAlignment[VerticalAlignment["TOP"] = 2] = "TOP";
    VerticalAlignment[VerticalAlignment["MIDDLE"] = 3] = "MIDDLE";
    VerticalAlignment[VerticalAlignment["BOTTOM"] = 4] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
export var UnderlineStyle;
(function (UnderlineStyle) {
    UnderlineStyle[UnderlineStyle["NONE"] = 0] = "NONE";
    UnderlineStyle[UnderlineStyle["UNDERLINE"] = 1] = "UNDERLINE";
    UnderlineStyle[UnderlineStyle["STRIKETHROUGH"] = 2] = "STRIKETHROUGH";
})(UnderlineStyle || (UnderlineStyle = {}));
export var ItalicStyle;
(function (ItalicStyle) {
    ItalicStyle[ItalicStyle["NONE"] = 0] = "NONE";
    ItalicStyle[ItalicStyle["ITALIC"] = 1] = "ITALIC";
})(ItalicStyle || (ItalicStyle = {}));
export var DateFormat;
(function (DateFormat) {
    DateFormat[DateFormat["DEFAULT_LOCALE_BASED"] = 1] = "DEFAULT_LOCALE_BASED";
    DateFormat[DateFormat["MMMM_D_YYYY"] = 2] = "MMMM_D_YYYY";
    DateFormat[DateFormat["MMM_D_YYYY"] = 3] = "MMM_D_YYYY";
    DateFormat[DateFormat["D_MMM_YYYY"] = 4] = "D_MMM_YYYY";
    DateFormat[DateFormat["YYYY_MM_DD_HYPHEN"] = 5] = "YYYY_MM_DD_HYPHEN";
    DateFormat[DateFormat["YYYY_MM_DD_DOT"] = 6] = "YYYY_MM_DD_DOT";
    DateFormat[DateFormat["DWWWW_MMMM_D_YYYY"] = 7] = "DWWWW_MMMM_D_YYYY";
    DateFormat[DateFormat["DWWW_DD_MMM_YYYY"] = 8] = "DWWW_DD_MMM_YYYY";
    DateFormat[DateFormat["DWWW_MM_DD_YYYY"] = 9] = "DWWW_MM_DD_YYYY";
    DateFormat[DateFormat["MMMM_D"] = 10] = "MMMM_D";
    DateFormat[DateFormat["D_MMMM"] = 11] = "D_MMMM";
})(DateFormat || (DateFormat = {}));
export var Currency;
(function (Currency) {
    Currency[Currency["NONE"] = 0] = "NONE";
    Currency[Currency["ARS"] = 1] = "ARS";
    Currency[Currency["AUD"] = 2] = "AUD";
    Currency[Currency["BRL"] = 3] = "BRL";
    Currency[Currency["CAD"] = 4] = "CAD";
    Currency[Currency["CHF"] = 5] = "CHF";
    Currency[Currency["CLP"] = 6] = "CLP";
    Currency[Currency["CNY"] = 7] = "CNY";
    Currency[Currency["CZK"] = 8] = "CZK";
    Currency[Currency["DKK"] = 9] = "DKK";
    Currency[Currency["EUR"] = 10] = "EUR";
    Currency[Currency["GBP"] = 11] = "GBP";
    Currency[Currency["HKD"] = 12] = "HKD";
    Currency[Currency["ILS"] = 13] = "ILS";
    Currency[Currency["INR"] = 14] = "INR";
    Currency[Currency["JPY"] = 15] = "JPY";
    Currency[Currency["KRW"] = 16] = "KRW";
    Currency[Currency["MXN"] = 17] = "MXN";
    Currency[Currency["MYR"] = 18] = "MYR";
    Currency[Currency["NOK"] = 19] = "NOK";
    Currency[Currency["NZD"] = 20] = "NZD";
    Currency[Currency["PHP"] = 21] = "PHP";
    Currency[Currency["PLN"] = 22] = "PLN";
    Currency[Currency["RON"] = 23] = "RON";
    Currency[Currency["RUB"] = 24] = "RUB";
    Currency[Currency["SEK"] = 25] = "SEK";
    Currency[Currency["SGD"] = 26] = "SGD";
    Currency[Currency["TWD"] = 27] = "TWD";
    Currency[Currency["USD"] = 28] = "USD";
    Currency[Currency["VND"] = 29] = "VND";
    Currency[Currency["YTL"] = 30] = "YTL";
    Currency[Currency["ZAR"] = 31] = "ZAR"; // South Africa
})(Currency || (Currency = {}));
//# sourceMappingURL=Format.js.map